import React from 'react';
import get from 'lodash/get';
import FormContext from './context';

export default () => WrappedComponent => (
  class BindToForm extends React.Component {
    // eslint-disable-next-line react/sort-comp
    static contextType = FormContext;

    constructor(props) {
      super(props);

      this.handleBlur = this.handleBlur.bind(this);
    }

    getProps() {
      const {
        values,
        handleChange,
        isSubmitting,
        touched,
        errors,
        id,
      } = this.context;
      const { name, disabled } = this.props;

      return {
        value: get(values, name),
        checked: typeof get(values, name) === 'boolean' ? get(values, name) : undefined,
        touched: get(touched, name) || false,
        error: get(errors, name),
        onChange: handleChange,
        onBlur: this.handleBlur,
        ...this.props,
        disabled: isSubmitting || disabled,
        id: `${id}_${name}`,
      };
    }

    handleBlur(event) {
      const { handleBlur, setFieldValue } = this.context;
      const { name } = this.props;

      setFieldValue(name, event.target.value, true);
      handleBlur(event);
    }

    render() {
      return (
        <WrappedComponent {...this.getProps()} />
      );
    }
  }
);
